__turbopack_context__.v({
  "imageLinkLabel": "ImageSubNavItem-module__JUo5Mq__imageLinkLabel",
  "subNavImg": "ImageSubNavItem-module__JUo5Mq__subNavImg",
  "subNavImgContent": "ImageSubNavItem-module__JUo5Mq__subNavImgContent",
  "subNavImgDate": "ImageSubNavItem-module__JUo5Mq__subNavImgDate",
  "subNavImgDescription": "ImageSubNavItem-module__JUo5Mq__subNavImgDescription",
  "subNavImgLink": "ImageSubNavItem-module__JUo5Mq__subNavImgLink",
  "subNavImgRating": "ImageSubNavItem-module__JUo5Mq__subNavImgRating",
});
